
import { defineComponent, reactive } from 'vue'

// components
import TheInput from '@/common/components/UI/TheInput/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

export default defineComponent({
    components: {
        'the-input': TheInput,
        'the-button': TheButton,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['reset', 'search'],
    setup(props, { emit }) {
        const state = reactive({
            name: undefined as string | undefined,
        })

        const reset = () => {
            state.name = undefined

            emit('reset')
        }

        const search = () => {
            emit('search', {
                name: state.name,
            })
        }

        return {
            state,
            reset,
            search,
        }
    },
})
